app.run(run);

run.$inject = ['$rootScope', '$window'];
function run($rootScope, $window) {
  angular.element($window).on('resize', function() {
    $rootScope.$broadcast('RESIZE_PIPELINE');
  });

  $rootScope.$on('RESIZE_PIPELINE', function() {
    $rootScope.$broadcast('PRE_RESIZE');
    $rootScope.$broadcast('RESIZE');
    $rootScope.$broadcast('POST_RESIZE');
  });
}
